import React from 'react';
import './style.scss';
import CreamCan from '../../../../../../assets/images/common/creamCan';
import clsx from 'clsx';

interface CreamProps {
  isWin: boolean;
  isDraw: boolean;
  bet: number;
  className?: string;
}

const FightResultsCreamBlock = ({
  isWin,
  isDraw,
  bet,
  className
}: CreamProps) => {
  if (bet === 0) {
    if (isWin)
      return (
        <Wrapper className={className}>
          <h5>You won</h5>
        </Wrapper>
      );
    if (isDraw)
      return (
        <Wrapper className={className}>
          <h5>Wanna try again?</h5>
        </Wrapper>
      );
    return (
      <Wrapper className={className}>
        <h5>You lost</h5>
      </Wrapper>
    );
  }
  if (isWin) {
    return (
      <Wrapper className={className}>
        <p className='caption'>Your $CREAM gain:</p>
        <div className='frc-value'>
          <span>+{bet * 2}</span>
          <CreamCan className='frc-can' />
        </div>
      </Wrapper>
    );
  }
  if (isDraw) {
    return (
      <Wrapper className={className}>
        <h5>You got your {bet} $CREAM back</h5>
      </Wrapper>
    );
  }
  return (
    <Wrapper className={className}>
      <h5>You lost {bet} $CREAM</h5>
    </Wrapper>
  );
};

interface WrapperProps {
  className?: string;
  children: React.ReactNode;
}

const Wrapper = ({ className, children }: WrapperProps) => (
  <div className={clsx('fight-results-cream', className)}>{children}</div>
);

export default FightResultsCreamBlock;
